/* eslint-disable no-undef */
import React, { useState, useEffect, useRef ,useCallback} from "react";
import Select from 'react-select'
import logo from "../assets/images/way2news.png";
import menuSvg from "../assets/images/hamburger.svg";
import "../assets/styles/header.scss";
import profileAvatar from "../assets/images/ic-profile.png";
import api from "../services/api";
import Modal from "react-bootstrap/Modal";
import { useNavigate } from "react-router-dom";
import Datepicker from "react-tailwindcss-datepicker";
import CryptoJS from "crypto-js";
import config from "../config";
import {
  SlButton,
  SlInput,
  SlSelect,
  SlDrawer,
  SlIcon,
  SlOption,
} from "@shoelace-style/shoelace/dist/react";
import { useDispatch, useSelector } from "react-redux";
import {
  SetOpsSales,
  Headersearch,
  SetDate,
  SetNetworkAdtype,
  SetClickCamp,
  SetRegionLocation,
  SetNetworkAddate,
  SetNetworkAdsearch,
  SetShowsideNav,
  SetSalesUsersList,
  setSalesTeam,
  setSubordinates
} from "../redux/counterSlice";
import { debounce } from "../utils/Debounce";
import { roles } from "../utils/constants";
import {formatDateWithTime} from "../utils/dateFormat"
import { Toast } from "../shared/Toast";
import NotificatinAudio from "../assets/notification.wav";
// import { socket } from "../socket";
import filterSvg from "./../assets/images/filter.svg";
import NoDataFound from "./../assets/images/notFound.avif";
 
function Header() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [value, setValue] = useState({
    startDate: "",
    endDate: "",
  });

  const [data, setData] = useState([]);
  const [locationsdata, setlocationsdata] = useState([]);
  const [regionsdata, setregionsdata] = useState([]);
  const [showapprove, setShowApprove] = useState(false);
  const HeaderSearch = useSelector((state) => state.Head.adssearch);
  const Headdate = useSelector((state) => state.Head.date);
  const showSidenav = useSelector((state) => state.Head.showSideNav);
  const SALES = useSelector((state) => state.Head.opssales);
  const salesUsersList = useSelector((state) => state.Head.subordinates);
  const [saleop, setsaleop] = useState("0");
  const [region, setregion] = useState("region-0");
  const [netoworksearch, SetNetworkSearch] = useState("");
  const [location, setlocation] = useState("location-0");
  const component = useSelector((state) => state.Head.component_id);
  const [user_type, setuser_type] = useState("0");
  const [profile, setProfile] = useState(false);
  const [regionexists, setRegionExists] = useState();
  const [locationexists, setLocationExists] = useState();
  const [sourcetype, setSourceType] = useState("All");
  const [salesRegionExists, setSalesRegionExists] = useState(0);
  const [mainSalesUser, setMainSalesUser] = useState(0);
  const [notifications, setNotifications] = useState([]);
  const [salesNotifications, setSalesNotifications] = useState([]);
  const [notify, setNotify] = useState(false);
  const audioRef = useRef();
  const [showNotifications, setShowNotifications] = useState(false);
  const [mainUsersArray, setMainUsersArray] = useState([]);
  const [selectedUserOfMain, setSelectedUserOfMain] = useState(roles.ops);
  const [showFilter, setShowFilter] = useState(false);
  const [notificationLoader, setNotificationLoader] = useState(false);
  const [defaultDate, setDefaultDate] = useState(() => {
    const currentDate = new Date();
    const formattedDate = currentDate.toISOString().slice(0, 10);
    return formattedDate;
  });
  const [showSalesNotifications, setShowSalesNotifications] = useState(false);
  const [initialRender, setIntialRender] = useState(true)
  const [dshboardUsers, setDshboradUsers] = useState([])

  const [showWebpushNotifications,setShowWebpushNotifications] = useState(false);
  const [webnotifications, setwebNotifications] = useState([]);
  const [webpage, setwebPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [pushload,setpushload] = useState(false);

  const handleScroll = (e) => {
    const bottom = e.target.scrollHeight === e.target.scrollTop + e.target.clientHeight;
    if (bottom) {
      setwebPage(prevPage => prevPage + 1);
    }
  };
  const handleNotificationClick = async(noti_id,isread) => {
    if(isread)
    isread=0;
    else
    isread=1;

    try{
      let res = await api({
        url: `/pushSubscription/UpdateReadStatus`,
        method: "POST",
        responseType: "json",
        data: {noti_id,isread}
      });
      setpushload(false);
      setHasMore(true);
      setwebPage(1)
      setwebNotifications([]);
      setShowWebpushNotifications(false);
      if(localStorage.getItem('role') == 'w@y2n3m$Ad$-OPS')
      navigate("/home/alpha-designer");
    }catch(err)
    {
      console.log(err);
    }
  };
  const fetchwebpushNotifications = useCallback(async () => {
    setpushload(true);
    try {
      let res = await api({
        url: `/pushSubscription/getWebPushNotifications`,
        method: "POST",
        responseType: "json",
        data: {page:webpage,limit:config.PER_PAGE}
      });
      if(res.code == 200)
      {
        const newNotifications = res?.data || [];
        if (newNotifications.length < config.PER_PAGE) {
          setHasMore(false);
        }
        setwebNotifications(prevNotifications => [
          ...prevNotifications,
          ...newNotifications,
        ]);
      }

    } catch (error) {
      console.error("Error fetching notifications:", error);
    } finally {
      setpushload(false);
    }
  }, [webpage]);
  
  // useEffect(()=>{
  //   if(localStorage.getItem("role") === roles.ops || localStorage.getItem("role") === roles.designer)
  //   { console.log("api called");
  //     fetchwebpushNotifications();
  //   }
  // },[])

  useEffect(()=>{
    fetchwebpushNotifications();
  },[webpage])

  const opsSalesOnChange = async(data) => {
    try {
      let res = await api({
        url: "/user/sales_persons/opssales",
        method: "POST",
        responseType: "json",
        data,
      });
      if (res?.data) setData([{label: "All Users", value: 0, index: 0},...res.data]);
      if(res?.data && initialRender){
        let salesUsersList = JSON.parse(JSON.stringify(res.data))
        dispatch(SetSalesUsersList([...(salesUsersList.map(item => {if(item.label.includes('(CST)')){return false}; item.label = item.label.replace(' (Sales)', ''); delete item.index; delete item.type; return item})).filter(item => item)]))
        setIntialRender(false)
      }
    } catch (error) {
      console.error(error);
      if (error.response.status === 401) navigate("/");
    }
  }

  const onSourceChange = (e) => {
    setSourceType(e.target.value);
    dispatch(SetNetworkAdtype(e.target.value));
  };

  const onTypeChange = async (e) => {
    setuser_type(e.target.value);
    if (e.target.value !== "0") {
      try {
        let res = await api({
          url: "/user/sales_persons/getregionsofheader",
          method: "POST",
          responseType: "json",
          data: { user_type: e.target.value },
        });
        // setlocationsdata(res.data.locations)
        // console.log(res.data)
        if (res?.data?.length) setregionsdata([...res.data]);
      } catch (error) {
        console.error(error);
        if (error.response.status === 401) navigate("/");
      }
    } else {
      setregionsdata([]);
    }
    try {
      await opsSalesOnChange({
        user_type: parseInt(e.target.value),
        type: "user_type",
      })
    } catch (error) {
      console.error(error);
      if (error.response.status === 401) navigate("/");
    }
    dispatch(
      SetRegionLocation({
        user_type: e.target.value,
        value: "0",
        type: "user_type",
      })
    );
    dispatch(
      SetOpsSales({
        index: e.target.value,
        label:
          e.target.value === "1"
            ? "National"
            : e.target.value === "2"
            ? "Local"
            : "All",
        user_type: e.target.value,
        value: e.target.value,
        type: "user_type",
      })
    );
    setregion("region-0");
    setlocation("location-0");
    setlocationsdata([]);
    setsaleop("0");
    setDshboradUsers([])
  };

  const getlocationssdata = async (region) => {
    try {
      let res = await api({
        url: "/user/sales_persons/getlocationsofheader",
        method: "POST",
        responseType: "json",
        data: { region },
      });
      if (res?.data?.length) setlocationsdata([...res.data]);
      // setregionsdata(res.data.regions)
    } catch (error) {
      console.error(error);
      if (error.response.status === 401) navigate("/");
    }
  };
  function handleRequestClose(event) {
    if (event.detail.source === "overlay") {
      event.preventDefault();
    }
  }
  function handlWebNotificationRequestClose(event){
    if(event.detail.source === "overlay"){
      setpushload(false);
      setHasMore(true);
      setwebPage(1)
      setwebNotifications([]);
      setShowWebpushNotifications(false);
    }
  }
  const handleHdlBdyChange = (e) => {
    dispatch(SetNetworkAdsearch(e.target.value));
    SetNetworkSearch(e.target.value);
  };
  function getYesterdayDateUpdate() {
    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);

    const year = yesterday.getFullYear();
    const month = String(yesterday.getMonth() + 1).padStart(2, "0");
    const day = String(yesterday.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  }

  function todayDate() {
    let today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }
  function getYesterdayDate() {
    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(today.getDate() - 1);

    const year = yesterday.getFullYear();
    const month = String(yesterday.getMonth() + 1).padStart(2, "0");
    const day = String(yesterday.getDate()).padStart(2, "0");

    return `${day}-${month}-${year}`;
  }
  const handleApproveYesterday = async () => {
    try {
      const res = await api({
        url: `/networkads/approvequeued`,
        method: "POST",
        responseType: "json",
        data: {
          date: getYesterdayDateUpdate(),
        },
      });
      if (res.code === 200) {
        setShowApprove(false);
        Toast("success", "Approved Successfully");
      } else {
        Toast("error", res.data.message);
      }
    } catch (error) {
      console.error(error);
    }
  };
  const yeseterdayQueued = async () => {
    try {
      if (localStorage.getItem("role") !== roles.b2b) {
        const res = await api({
          url: `/networkads/queuedCount`,
          method: "POST",
          responseType: "json",
          data: {
            date: getYesterdayDateUpdate(),
          },
        });
        if (res?.code === 200) {
          if (res?.data > 0 && defaultDate === todayDate()) {
            setShowApprove(true);
          }
        }
      }
    } catch (error) {}
  };
  const handleValueChange = (newValue) => {
    setValue(newValue);
    dispatch(SetDate(newValue));
  };
  const handleDismiss = () => {
    localStorage.setItem("show", false);
    setShowApprove(false);
  };
  const [hours, setHours] = useState(0);
  const [minutes, setMinutes] = useState(0);
  const [seconds, setSeconds] = useState(0);
  const [searchValue, setSearchValue] = useState("");
  useEffect(() => {
    setSearchValue(HeaderSearch);
  }, [HeaderSearch]);

  useEffect(() => {
    if (Headdate === "") {
      setValue({
        startDate: null,
        endDate: null,
      });
    }
  }, [Headdate]);

  // useEffect(() => {
  //     setSearchValue(HeaderSearch)
  // }, [SALES])

  useEffect(() => {
    if (
      localStorage.getItem("role") !== roles.b2b &&
      localStorage.getItem("role") !== roles.network_ad_manager
    ) {
      if (localStorage.getItem("role") !== roles.salesperson) {
        onlocationchange("");
      }
      const interval = setInterval(updateCountdown, 1000);
      return () => {
        clearInterval(interval);
      };
    }
  }, []);

  useEffect(() => {
    let encodeMainUser = localStorage.getItem("main_user");
    try {
      if (encodeMainUser) {
        const decryptedMainUserPermissions = CryptoJS.AES.decrypt(
          encodeMainUser,
          config.B2B_SECRET_KEY
        );
        let usersArray = JSON.parse(
          decryptedMainUserPermissions.toString(CryptoJS.enc.Utf8)
        );
        if (typeof usersArray !== "object") {
          logout();
        }
        usersArray.map((item) => {
          if (item.role === roles.salesperson) {
            item.label = "Sales";
            item.value = item.role;
          }
          if (item.role === roles.financer) {
            item.label = "Finance";
            item.value = item.role;
          }
          if (item.role === roles.b2b) {
            item.label = "B2B";
            item.value = item.role;
          }
          if (item.role === roles.legalperson) {
            item.label = "Legal";
            item.value = item.role;
          }
          if (item.role === roles.ops) {
            item.label = "CST";
            item.value = item.role;
          }
        });
        setMainUsersArray(usersArray);
      }
    } catch (error) {
      console.error("Error @ UseEffect of Main User in Header", error);
      logout();
    }
  }, [selectedUserOfMain]);

  const navigating = (role) => {
    dispatch(
      SetOpsSales({
        index: 0,
        value: 0,
      })
    );
    dispatch(
      SetRegionLocation({ user_type: 0, value: "0", type: "user_type" })
    );
    dispatch(SetDate(""));
    dispatch(Headersearch(""));
    dispatch(SetClickCamp(-1));
    dispatch(SetNetworkAdtype("All"));
    dispatch(SetNetworkAddate(""));
    setuser_type("0");
    setregion("region-0");
    setlocation("location-0");
    setsaleop("0");
    setDshboradUsers([])
    SetNetworkSearch("");
    setValue({
      startDate: "",
      endDate: "",
    });
    navigate("/home");
    if (role === roles.ops) navigate("/home/order", {});
    else if (role === roles.salesperson) {
      if (localStorage.getItem("discount-obj")?.length > 0) {
        navigate(`/home/discount/${localStorage.getItem("discount-obj")}`);
      }
      else if(localStorage.getItem('slot-id')?.length > 0){
        navigate(`/home/slotbooking/${localStorage.getItem('slot-id')}`)
      }
      else navigate("/home/sales/dashboard");
    } else if (role === roles.financer) navigate("/home/order");
    else if (role === roles.advertiser) navigate("/home/dashboard");
    else if (role === roles.network_ad_manager)
      navigate("/home/networkads/queued");
    else if (role === roles.legalperson) {
      if (localStorage.getItem("discount-obj")?.length > 0) {
        navigate(`/home/discount/${localStorage.getItem("discount-obj")}`);
      } else navigate("/home/order");
    } else if (role === roles.b2b && localStorage.getItem("b2b")) {
      const encryptedPermissions = localStorage.getItem("b2b");

      // Decrypt the permissions with the same secret key
      const decryptedPermissionsBytes = CryptoJS.AES.decrypt(
        encryptedPermissions,
        config.B2B_SECRET_KEY
      );

      // Convert the decrypted bytes back to a JSON string
      const decryptedPermissionsJSON = decryptedPermissionsBytes.toString(
        CryptoJS.enc.Utf8
      );

      // Parse the JSON string to get the original object
      const b2b_permissions = JSON.parse(decryptedPermissionsJSON)[0];

      if (b2b_permissions.newspaperData) {
        navigate("/home/competitor_data/get");
      } else if (b2b_permissions.b2bData) {
        navigate("/home/b2b_contacts/get");
      } else if (b2b_permissions.agencyData) {
        navigate("/home/agency_data/get");
      } else if (b2b_permissions.competitorData) {
        navigate("/home/competitor_reports/get");
      } else if (b2b_permissions.requests) {
        navigate("/home/b2b_requests/get");
      } else {
        navigate("/home/competitor_data/get");
      }
    }else {
      console.log(role,roles);
      navigate("/pagenotfound");
    }
  };

  const onMainUserOptionChange = (e) => {
    setSelectedUserOfMain(e.target.value);
    let selecteduser = mainUsersArray.find(
      (item) => item.role === e.target.value
    );
    localStorage.setItem("token", selecteduser.authorization);
    localStorage.setItem("role", selecteduser.role);
    localStorage.setItem("name", selecteduser.name);
    localStorage.setItem("expiry", selecteduser.expiry);
    localStorage.setItem("email", selecteduser.email);
    localStorage.setItem("show", true);
    localStorage.setItem("type", selecteduser.type);
    if (selecteduser.role === roles.salesperson) {
      if(selecteduser?.team){
        const encryptedTeam = CryptoJS.AES.encrypt(selecteduser?.team, config.B2B_SECRET_KEY).toString();
        localStorage.setItem("sales_team", encryptedTeam);
      }
      let encryptedSalesTabPermissions = CryptoJS.AES.encrypt(
        "Main",
        config.B2B_SECRET_KEY
      ).toString();
      localStorage.setItem("salesTabFlag", encryptedSalesTabPermissions);
      salesUserDetails();
    } else {
      localStorage.removeItem("salesTabFlag");
    }
    if (selecteduser.role === roles.b2b) {
      const permissionsJSON = JSON.stringify(selecteduser.b2b_permissions);

      const encryptedPermissions = CryptoJS.AES.encrypt(
        permissionsJSON,
        config.B2B_SECRET_KEY
      ).toString();

      localStorage.setItem("b2b", encryptedPermissions);
    } else {
      localStorage.removeItem("b2b");
    }

    navigating(selecteduser.role);
  };

  const networkadsDateChange = (e) => {
    setDefaultDate(e.target.value);
  };

  const changeNameHandler = (e) => {
    let selectedLabel = { value: -1, label: "", index: -1 };
    if (parseInt(e.target.value) === 0) {
      if (region === "region-0" && location === "location-0") {
        dispatch(
          SetOpsSales({
            index: user_type,
            label:
              user_type === "1"
                ? "National"
                : user_type === "2"
                ? "Local"
                : "All",
            user_type: user_type,
            value: user_type,
            type: "user_type",
          })
        );
      } else {
        const pattern = /^(.*?)-(\d+)$/;
        const regex = new RegExp(pattern);
        const matches = regex.exec(location);
        if (matches) {
          if (parseInt(matches[2]) === 0) {
            const patternr = /^(.*?)-(\d+)$/;
            const regexr = new RegExp(pattern);
            const matchesr = regex.exec(region);
            dispatch(
              SetRegionLocation({
                type: "region",
                value: matchesr[2],
                user_type: user_type,
              })
            );
            dispatch(
              SetOpsSales({
                index: matchesr[2],
                type: matchesr[1],
                value: matchesr[2],
                label:
                  parseInt(matchesr[2]) === 0
                    ? "All"
                    : regionsdata.filter(
                        (item) => item.value === parseInt(matchesr[2])
                      )[0]?.label,
                user_type: user_type,
              })
            );
          } else {
            dispatch(
              SetRegionLocation({
                type: "location",
                value: matches[2],
                user_type: user_type,
              })
            );
            dispatch(
              SetOpsSales({
                index: matches[2],
                type: matches[1],
                value: matches[2],
                label: locationsdata.filter(
                  (item) => item.value === parseInt(matches[2])
                )[0]?.label,
                user_type: user_type,
              })
            );
          }
        }
      }
      // dispatch(SetOpsSales({index :0, label : "All",type: "user", value: 0}))
      setsaleop(e.target.value);
      // setlocation('location-0')
      // setregion('region-0')
    } else {
      for (let i = 0; i < data.length; i++) {
        if (parseInt(data[i].index) === parseInt(e.target.value)) {
          selectedLabel.value = data[i].value;
          selectedLabel.label = data[i].label;
          selectedLabel.index = data[i].index;
          selectedLabel.type = data[i].type;
          // selectedLabel.user_type = user_type;
        }
      }
      setsaleop(e.target.value);
      // setlocation('location-0')
      // setregion('region-0')
      dispatch(SetOpsSales(selectedLabel));
    }
  };

  function updateCountdown() {
    const currentTime = Math.floor(new Date().getTime() / 1000);
    const expiryTime = parseInt(localStorage.getItem("expiry"));
    const remainingTime = expiryTime - currentTime;
    if (remainingTime <= 0) {
      return;
    }

    const remainingHours = Math.floor(remainingTime / 3600);
    const remainingMinutes = Math.floor((remainingTime % 3600) / 60);
    const remainingSeconds = remainingTime % 60;

    setHours(remainingHours);
    setMinutes(remainingMinutes);
    setSeconds(remainingSeconds);
  }
  const searchData = (e) => {
    setSearchValue(e.target.value);
  };

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      dispatch(Headersearch(searchValue));
    }, 500);

    return () => {
      clearTimeout(timeoutId);
    };
  }, [searchValue]);

  const salesUserDetails = async () => {
    try {
      let res = await api({
        url: "/user/sales_persons/salesUsersDetails",
        method: "POST",
        responseType: "json",
      });
      // setlocationsdata(res.data.locations)
      if (res?.data) {
        setregionsdata(res.data.regionData.options);
        setregion(res.data.regionData.value);
        setlocationsdata(res.data.locationsData.options);
        setlocation(res.data.locationsData.value);
        setuser_type(`${res.data.user_type}`);
        setRegionExists(res.data.regionData.exists);
        setData([{label: "All Users", value: 0, index: 0},...res.data.sales_list]);
        setLocationExists(res.data.locationsData.id);
        dispatch(
          setSalesTeam(res.data.new_user_type)
        )
        setsaleop(0);
        setDshboradUsers([])
        
        if (!res.data.regionData.exists) {
          if(initialRender){
            let salesUsersList = JSON.parse(JSON.stringify(res.data.sales_list))
            dispatch(SetSalesUsersList([...(salesUsersList.map(item => {if(item.label.includes('(CST)')){return false}; item.label = item.label.replace(' (Sales)', ''); delete item.index; delete item.type; return item})).filter(item => item)]))
            setIntialRender(false)
          }
          dispatch(
            SetOpsSales({
              index: res.data.user_type,
              label:
                res.data.user_type === 1
                  ? "National"
                  : res.data.user_type === 2
                  ? "Local"
                  : "All",
              user_type: res.data.user_type,
              value: res.data.user_type,
              type: "user_type",
            })
          );
          dispatch(
            SetRegionLocation({
              user_type: res.data.user_type,
              value: res.data.user_type,
              type: "user_type",
            })
          );
          setSalesRegionExists(1);
          if (
            res.data.regionData.options.length === 0 &&
            res.data.locationsData.options.length === 0
          ) {
            dispatch(
              SetOpsSales({
                index: "0",
                label: "All",
                user_type: "0",
                value: "0",
                type: "user_type",
              })
            );
            dispatch(
              SetRegionLocation({
                user_type: "0",
                value: "0",
                type: "user_type",
              })
            );

            setMainSalesUser(1);
          }
        } else if (
          res.data.user_type === 1 &&
          res.data.locationsData.value === "location-0"
        ) {
          if(initialRender){
            let salesUsersList = JSON.parse(JSON.stringify(res.data.sales_list))
            dispatch(SetSalesUsersList([...(salesUsersList.map(item => {if(item.label.includes('(CST)')){return false}; item.label = item.label.replace(' (Sales)', ''); delete item.index; delete item.type; return item})).filter(item => item)]))
            setIntialRender(false)
          }
          dispatch(
            SetOpsSales({
              index: res.data.regionData.id,
              label: res.data.regionData.label,
              user_type: res.data.user_type,
              value: res.data.regionData.id,
              type: "region",
            })
          );
          dispatch(
            SetRegionLocation({
              user_type: res.data.user_type,
              value: res.data.regionData.id,
              type: "region",
            })
          );
        } else if (
          res.data.user_type === 2 &&
          res.data.locationsData.value === "location-0"
        ) {
          if(initialRender){
            let salesUsersList = JSON.parse(JSON.stringify(res.data.sales_list))
            dispatch(SetSalesUsersList([...(salesUsersList.map(item => {if(item.label.includes('(CST)')){return false}; item.label = item.label.replace(' (Sales)', ''); delete item.index; delete item.type; return item})).filter(item => item)]))
            setIntialRender(false)
          }
          dispatch(
            SetOpsSales({
              index: res.data.regionData.id,
              label: res.data.regionData.label,
              user_type: res.data.user_type,
              value: res.data.regionData.id,
              type: "region",
            })
          );
          dispatch(
            SetRegionLocation({
              user_type: res.data.user_type,
              value: res.data.regionData.id,
              type: "region",
            })
          );
        } else {
          dispatch(
            SetOpsSales({
              index: res.data.locationsData.id,
              label: res.data.locationsData.label,
              user_type: res.data.user_type,
              value: res.data.locationsData.id,
              type: "location",
            })
          );
          dispatch(
            SetRegionLocation({
              user_type: res.data.user_type,
              value: res.data.locationsData.id,
              type: "location",
            })
          );
        }
      }
    } catch (error) {
      console.error(error);
      if (error.response.status === 401) navigate("/");
    }
  };

  useEffect(() => {
    if (
      localStorage.getItem("role") === roles.salesperson &&
      (component === 3 || component === 12 || component === 35 || component === 36 || component === 39 || component === 33 || component === 45 || component === 48 || component === 52) 
    ) {
      salesUserDetails();
    }
  }, [component]);

  const logout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("role");
    localStorage.removeItem("name");
    localStorage.removeItem("email");
    localStorage.removeItem("expiry");
    localStorage.removeItem("show");
    localStorage.removeItem("salesTabFlag");
    localStorage.removeItem("type");
    localStorage.removeItem("discount-obj");
    localStorage.removeItem("main_user");
    localStorage.removeItem("selectedSalesList");
    localStorage.removeItem("discount-obj")
    localStorage.removeItem("slot-id")
    localStorage.removeItem("sales_team")
    dispatch(SetOpsSales(""));
    dispatch(
      SetRegionLocation({ user_type: 0, value: "0", type: "user_type" })
    );
    dispatch(SetDate(""));
    dispatch(Headersearch(""));
    dispatch(SetClickCamp(-1));
    dispatch(SetNetworkAdtype("All"));
    dispatch(SetNetworkAddate(""));
    dispatch(SetSalesUsersList([]))
    dispatch(setSalesTeam(1))
    dispatch(setSubordinates([]))
    navigate("/");
  };
  const handleClose = () => {
    setProfile(false);
  };
  const onregionchange = async (e) => {
    let data = {};
    if (e !== "") {
      setregion(e.target.value);
      const pattern = /^(.*?)-(\d+)$/;
      const regex = new RegExp(pattern);
      const matches = regex.exec(e.target.value);
      if (matches) {
        await getlocationssdata(parseInt(matches[2]));
        data.type = matches[1];
        data.value = matches[2];
        data.user_type = user_type;
        if (data.value === "0") {
          setlocationsdata([]);
          dispatch(
            SetRegionLocation({
              user_type: user_type,
              value: "0",
              type: "user_type",
            })
          );
          dispatch(
            SetOpsSales({
              index: user_type,
              label:
                user_type === "1"
                  ? "National"
                  : user_type === "2"
                  ? "Local"
                  : "All",
              user_type: user_type,
              value: user_type,
              type: "user_type",
            })
          );
        } else {
          dispatch(
            SetRegionLocation({
              value: parseInt(matches[2]),
              type: "region",
              user_type: user_type,
            })
          );
          dispatch(
            SetOpsSales({
              index: matches[2],
              type: matches[1],
              value: matches[2],
              label:
                parseInt(matches[2]) === 0
                  ? "All"
                  : regionsdata.filter(
                      (item) => item.value === parseInt(matches[2])
                    )[0]?.label,
              user_type: user_type,
            })
          );
        }
      }
      setlocation("location-0");
      setsaleop("0");
      setDshboradUsers([])
    } else {
      data.type = "user";
      data.value = -1;
      data.user_type = user_type;
    }
    try {
      await opsSalesOnChange(data)
    } catch (error) {
      console.error(error);
      if (error.response.status === 401) navigate("/");
    }
  };
  const onlocationchange = async (e) => {
    let data = {};
    if (e !== "") {
      setlocation(e.target.value);
      const pattern = /^(.*?)-(\d+)$/;
      const regex = new RegExp(pattern);
      const matches = regex.exec(e.target.value);
      if (matches) {
        data.type = matches[1];
        data.value = matches[2];
        data.user_type = user_type;
        if (parseInt(matches[2]) === 0) {
          const patternr = /^(.*?)-(\d+)$/;
          const regexr = new RegExp(pattern);
          const matchesr = regex.exec(region);
          dispatch(
            SetRegionLocation({
              value: parseInt(matchesr[2]),
              type: "region",
              user_type: user_type,
            })
          );
          dispatch(
            SetOpsSales({
              index: matchesr[2],
              type: matchesr[1],
              value: matchesr[2],
              label:
                parseInt(matchesr[2]) === 0
                  ? "All"
                  : regionsdata.filter(
                      (item) => item.value === parseInt(matchesr[2])
                    )[0]?.label,
              user_type: user_type,
            })
          );
          data.type = matchesr[1];
          data.value = matchesr[2];
          data.user_type = user_type;
        } else {
          dispatch(
            SetRegionLocation({
              value: parseInt(matches[2]),
              type: "location",
              user_type: user_type,
            })
          );
          dispatch(
            SetOpsSales({
              index: matches[2],
              type: matches[1],
              value: matches[2],
              label: locationsdata.filter(
                (item) => item.value === parseInt(matches[2])
              )[0]?.label,
              user_type: user_type,
            })
          );
        }
      }
      setsaleop("0");
      setDshboradUsers([])
    } else {
      data.type = "user";
      data.value = -1;
    }
    if (localStorage.getItem("role") !== roles.advertiser && localStorage.getItem("role")!== roles.designer && localStorage.getItem("role")!== roles.content_writer) {
      try {
        await opsSalesOnChange(data)
      } catch (error) {
        console.error(error);
        if (error.response?.status === 401) navigate("/");
      }
    }
  };
  const fetchNotifications = async () => {
    try {
      let res = await api({
        url: "/order/notifications",
        method: "POST",
        responseType: "json",
        data: {},
      });
      if (res.code === 200) {
        setNotifications(res.data);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const notificationsComplete = async () => {
    try {
      let res = await api({
        url: "/order/read-notifications",
        method: "POST",
        responseType: "json",
        data: {},
      });
      if (res.code === 200) {
        fetchNotifications();
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    dispatch(SetNetworkAddate(defaultDate));
    // yeseterdayQueued();
    if (localStorage.getItem("role") === roles.financer) fetchNotifications();
  }, [defaultDate]);

  // useEffect(() => {
  //   socket.on("update-messages", (data) => {
  //     setNotifications((prevNotifications) => [...prevNotifications, data]);
  //     audioRef.current.play();
  //     setNotify(true);
  //   });
  //   return () => {
  //     socket.off("update-messages");
  //   };

  // }, []);
  useEffect(() => {
    if(localStorage.getItem("main_user")){
      setSelectedUserOfMain(localStorage.getItem('role'))
    }
  },[])

  const defaultValue = (options, index) => {
    return options ? options.filter((option) => +option.index === +index) : "";
  };
  const defaultValueForDashbrdSales = (values) =>{
    return data.filter(item => +item.value !== 0)?.map((option) => {
      return ({ label: option.label, value: option.index });
    }).filter(item => values.includes(item.value))
    }

  const fetchSalesNotifications = async () => {
    setNotificationLoader(true)
    try {
      let res = await api({
        url: "/accountManagement/getRemainders",
        method: "POST",
        responseType: "json",
        data: {},
      });
      if (res.code === 200) {
        setSalesNotifications(res.data);
      }
    } catch (error) {
      console.error(error);
    }
    finally{
      setNotificationLoader(false)
    }
  };

  useEffect(() =>{
    if(localStorage.getItem('role') === roles.salesperson)
    fetchSalesNotifications();
  },[])

  const fetchSubordinates = async() => {
    try {
      let subordinatesResult = await api({
        url: "/user/sales_persons/getsubordinates",
        method: "POST",
        responseType: "json"
      })
      if(subordinatesResult.code === 200){
        dispatch(setSubordinates(subordinatesResult.data))
      }
      else{
        console.error(subordinatesResult.data.message)
      }
    } catch (error) {
      console.error("Error @ fetchSubordinates", error)
    }
  }

  useEffect(() => {
    if(localStorage.getItem('role') === roles.salesperson && component === 39){
      fetchSubordinates()
    }
  }, [component])

  return (
    <>
      <header className="header-main" style={{ zIndex: 3 }}>
        <div
          className="menuToggle"
          onClick={() => {
            dispatch(SetShowsideNav(!showSidenav));
          }}
        >
          <img src={menuSvg} alt="menu" />
        </div>
        <div className="header-h">
          <img src={logo} alt="way2news logo" />
        </div>
        {/* <h5 className='mr-4'>Welcome {localStorage.getItem("name")}</h5> */}
        <div className="hidden gap-3 ml-auto justify-end mt-4">
          {localStorage.getItem("role") === roles.network_ad_manager ? (
            showapprove === true && localStorage.getItem("show") === "true" ? (
              <div className="flex justify-end mb-3">
                <div
                  style={{ backgroundColor: "#fbfaff" }}
                  className=" flex w-max h-12 rounded align-center"
                >
                  <p className="font-medium m-2">{`Approve everything in queue yesterday (${getYesterdayDate()}) ?`}</p>
                  <SlButton
                    onClick={handleApproveYesterday}
                    size="small"
                    className="mt-2 mr-1"
                    variant="default"
                  >
                    Approve
                  </SlButton>
                  <SlButton
                    onClick={handleDismiss}
                    size="small"
                    className="mt-2"
                    variant="default"
                  >
                    Dismiss
                  </SlButton>
                </div>
              </div>
            ) : null
          ) : null}
          {localStorage.getItem("role") === roles.network_ad_manager && (
            <SlInput
              placeholder="Search"
              type="text"
              onSlInput={debounce(handleHdlBdyChange, 1000)}
            ></SlInput>
          )}
          {localStorage.getItem("role") === roles.network_ad_manager && (
            <SlInput
              type="date"
              onSlChange={networkadsDateChange}
              value={defaultDate}
              placeholder="Date"
            ></SlInput>
          )}
          {localStorage.getItem("role") === roles.network_ad_manager ? (
            <SlSelect
              placeholder="Select Type"
              defaultValue={"all"}
              size="medium"
              onSlChange={onSourceChange}
              style={{ width: "133px" }}
              value={sourcetype}
            >
              <SlOption value="All">All</SlOption>
              <SlOption value="admob">Google</SlOption>
              <SlOption value="facebook">Facebook</SlOption>
            </SlSelect>
          ) : null}
        </div>
        <div className="mobHeaderActions flex items-center gap-2 justify-end mr-4 w-full">
          <>
            {component !== 7 && component !== 45 &&  component !== 48 &&  component !== 52  && component !== 39 && component !== 65 && component !== 67 && component !== 85 && component !== 86 &&
            localStorage.getItem("role") !== roles.network_ad_manager ? (
              <div className="d-flex align-items-center relative mobSearch min-w-[100px]">
                <input
                  className="form-control"
                  placeholder="search"
                  value={searchValue}
                  onChange={searchData}
                />
              </div>
            ) : null}
            <div className="flex items-center gap-3 justify-end mr-4 w-full mobHide">
              {(component === 15 &&
                roles.salesperson === localStorage.getItem("role") &&
                salesRegionExists === 0) ||
              component === 10 ||
              component === 26 ||
              component === 33 ||
              component === 35 ||
              component === 36 ||
              component === 38 ||
              component === 43 ||
              component === 45 ||
              component === 48 ||
              component === 52 ||
              component === 34 ||
              component === 42 ||
              component === 50 ||
              component === 65 ||
              component === 67 ||
              component === 80 ||
              component === 85 ||
              component === 86 ||
              component === 39  ? null : (
                <>
                  {(localStorage.getItem("role") === roles.ops ||
                    localStorage.getItem("role") === roles.financer ||
                    mainSalesUser === 1) &&
                  localStorage.getItem("role") !== roles.network_ad_manager &&
                  localStorage.getItem("role") !== roles.b2b ? (
                    <SlSelect
                      placeholder="Select Type"
                      defaultValue={"all"}
                      size="medium"
                      className="w-16"
                      onSlChange={onTypeChange}
                      style={{ width: "120px" }}
                      value={user_type}
                    >
                      {/* <sl-icon name="globe-central-south-asia" slot="prefix"></sl-icon> */}
                      <SlOption value="0">All</SlOption>
                      <SlOption value="1">National</SlOption>
                      <SlOption value="2">Local</SlOption>
                      {mainSalesUser === 1 && component === 1 && (
                        <SlOption value="3">Heads</SlOption>
                      )}
                    </SlSelect>
                  ) : null}
                  {localStorage.getItem("role") !== roles.advertiser &&
                  localStorage.getItem("role") !== roles.network_ad_manager &&
                  localStorage.getItem("role") !== roles.b2b && 
                  localStorage.getItem("role") !== roles.designer ? (
                    <SlSelect
                      placeholder="Select Region"
                      defaultValue={"all"}
                      size="medium"
                      disabled={
                        localStorage.getItem("role") === roles.salesperson &&
                        regionexists
                      }
                      onSlChange={onregionchange}
                      style={{ width: "144px" }}
                      value={region}
                    >
                      {/* <SlIcon library="lucide" name="map-pin" slot="prefix"></SlIcon> */}
                      <SlOption key={0} value={"region-0"}>
                        All Regions
                      </SlOption>
                      {regionsdata?.map((option) => (
                        <SlOption
                          key={option.index + 1}
                          value={option.type + "-" + option.value}
                        >
                          {option.label}
                        </SlOption>
                      ))}
                    </SlSelect>
                  ) : null}
                  {localStorage.getItem("role") !== roles.advertiser &&
                  localStorage.getItem("role") !== roles.network_ad_manager &&
                  localStorage.getItem("role") !== roles.b2b &&
                  localStorage.getItem("role") !== roles.designer &&
                  region ? (
                    <SlSelect
                      placeholder="Select Location"
                      defaultValue={"all"}
                      size="medium"
                      disabled={
                        localStorage.getItem("role") === roles.salesperson &&
                        regionexists &&
                        locationexists !== 0
                          ? true
                          : false
                      }
                      onSlChange={onlocationchange}
                      style={{ width: "140px" }}
                      value={location}
                    >
                      {/* <SlIcon library="lucide" name="locate-fixed" slot="prefix"></SlIcon> */}
                      <SlOption key={0} value={"location-0"}>
                        All Locations
                      </SlOption>
                      {locationsdata?.map((option) => (
                        <SlOption
                          key={option.index + 1}
                          value={option.type + "-" + option.value}
                        >
                          {option.label}
                        </SlOption>
                      ))}
                    </SlSelect>
                  ) : null}
                    {component !== 1 && (
                      <>
                        {(localStorage.getItem("role") !== roles.designer && (localStorage.getItem("role") === roles.ops ||
                          localStorage.getItem("role") === roles.financer || (localStorage.getItem('role') === roles.salesperson ? salesUsersList?.length > 1 : true))) ? (
                          <div>
                            <Select
                              className='w-36'
                              placeholder="Select User Name"
                              size="medium"
                              style={{ width: "140px" }}
                              value={defaultValue(data, saleop)}
                              onChange={(selected) => changeNameHandler({ target: { value: selected.value } })}
                              options={data?.map((option) => {
                                return ({ label: option.label, value: option.index });
                              })}
                            />
                          </div>
                        )
                          : null}
                      </>
                    )}
                      <>
                        {/* {(localStorage.getItem("role") === roles.ops ||
                          localStorage.getItem("role") === roles.financer || localStorage.getItem("role") === roles.salesperson) && component === 39 ? (
                          <div>
                            <Select
                              placeholder="Select User Name"
                              size="medium"
                              value={defaultValueForDashbrdSales(dshboardUsers)}
                              onChange={(selected) => setDshboradUsers(selected.map(item => item.value))}
                              options={data.filter(item => +item.value !== 0)?.map((option) => {
                                return ({ label: option.label, value: option.index });
                              })}
                              isMulti
                            />
                          </div>
                        )
                          : null} */}
                      </>
                </>
              )}
              {component !== 7 &&
              component !== 33 &&
              component !== 35 &&
              component !== 34 &&
              component !== 38 &&
              component !== 43 &&
              component !== 45 &&
              component !== 48 &&
              component !== 52 &&
              component !== 42 &&
              component !== 36 &&
              component !== 26 &&
              component !== 39 &&
              component !== 67 &&
              component !== 80 &&
              component !== 65 &&
              component !== 85 &&
              component !== 86 &&
              localStorage.getItem("role") !== roles.network_ad_manager &&
              localStorage.getItem("role") !== roles.b2b  &&
              localStorage.getItem("role") !== roles.designer ? (
                <div className="border rounded-lg  border-gray-300 hover:cursor-pointer hover:border-2 hover:border-sky-500 w-66">
                  <Datepicker
                    classNames="form-input"
                    value={value}
                    primaryColor={"cyan"}
                    showShortcuts={true}
                    // useRange={false}
                    configs={{
                      shortcuts: {
                        today: "today",
                        yesterday: "yesterday",
                        currentMonth: "currentMonth",
                        pastMonth: "lastMonth",
                      },
                    }}
                    onChange={handleValueChange}
                  />
                </div>
              ) : null}

              {localStorage.getItem("main_user") && (
                <div className="ml-auto">
                  <SlSelect
                    placeholder="Select User Type"
                    size="medium"
                    onSlChange={onMainUserOptionChange}
                    style={{ width: "140px" }}
                    value={selectedUserOfMain}
                  >
                    {/* <SlIcon library="lucide" name="locate-fixed" slot="prefix"></SlIcon> */}
                    {mainUsersArray?.map((option) => (
                      <SlOption key={option.index} value={option.value}>
                        {option.label}
                      </SlOption>
                    ))}
                  </SlSelect>
                </div>
              )}
            </div>
          </>
        </div>

        <Modal
          show={profile}
          onHide={handleClose}
          animation={false}
          className="right-corner-modal"
        >
          <Modal.Header>
            <Modal.Title>
              <div className="user-pro">
                <div className="d-flex align-items-center mb-0">
                  <p className="mb-0">{localStorage.getItem("name")}</p>
                  <p className="mb-0">
                    {localStorage.getItem("role") === roles.advertiser ? (
                      <>(Advertiser)</>
                    ) : localStorage.getItem("role") === roles.financer ? (
                      <>(Finance)</>
                    ) : localStorage.getItem("role") === roles.ops ? (
                      <>(CST)</>
                    ) : localStorage.getItem("role") ===
                      roles.network_ad_manager ? (
                      <>(NAM)</>
                    ) : localStorage.getItem("role") === roles.b2b ? (
                      <>(B2B)</>
                    ) : localStorage.getItem("role") === roles.legalperson ? (
                      <>(Legal)</>
                    ) : (
                      <>(Sales)</>
                    )}
                  </p>
                </div>
                <b className="text-xs ml-1 font-light">
                  {localStorage.getItem("email")}
                </b>
              </div>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {
              <div className="flex flex-row">
                <span className="text-black-600 whitespace-nowrap">
                  Session expires in:{" "}
                </span>
                <span className="text-red-400">
                  {hours}h {minutes}m {seconds}s
                </span>
              </div>
            }
            <SlButton
              className="ml-32 mt-1"
              size="medium"
              variant="primary"
              onClick={logout}
            >
              Logout
            </SlButton>
          </Modal.Body>
        </Modal>

        <SlDrawer
          label="Notifications"
          open={showNotifications}
          className="notification-board"
          onSlRequestClose={handleRequestClose}
          onSlAfterHide={() => {
            setShowNotifications(false);
            setNotify(false);
            notificationsComplete();
          }}
          style={{ '--size': `${window.innerWidth <= 767 ? '100vw' : '25vw' }`}}
        >
          {notifications.map((item, index) => {
            return (
              <div className="notification-view" key={index}>
                <h3>
                  <sl-icon-button
                    library="lucide"
                    name="megaphone"
                  ></sl-icon-button>
                  {item?.update?.message}
                </h3>
                <h5>{"Order Name: " + item?.update?.order_name}</h5>
                <h5>{"Update By: " + item?.update?.user}</h5>
              </div>
            );
          })}
        </SlDrawer>
        <SlDrawer
          label="Notifications"
          open={showSalesNotifications}
          className="notification-board"
          onSlRequestClose={handleRequestClose}
          onSlAfterHide={() => {
            setShowSalesNotifications(false);
           
          }}
          style={{ '--size': `${window.innerWidth <= 767 ? '100vw' : '25vw' }`}}
        >
          {!notificationLoader && (salesNotifications.events?.length > 0 || salesNotifications.remainders?.length > 0) ? <>
          {salesNotifications.events?.map((item, index) => {
            return (
              <div className="border rounded mb-1 p-2" key={index}>
                <h5>{item.name}</h5>
                <p className="text-xs text-gray-500 mb-1">{item.event_name}</p>
                <p>{item.description}</p>
              </div>
            );
          })}
          {salesNotifications.remainders?.map((item, index) => {
            return (
              <div className="border rounded mb-1 p-2" key={index}>
                <h5 className="capitalize">{item.brand_name}</h5>  
                <p>{item.description}</p>
              </div>
            );
          })}
          </> : <div className="flex justify-center items-center flex-col h-full"><svg data-v-5eed88b5="" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round" class="bird-icon flip" strokeWidth="1"><path d="M16 7h.01"></path><path d="M3.4 18H12a8 8 0 0 0 8-8V7a4 4 0 0 0-7.28-2.3L2 20"></path><path d="m20 7 2 .5-2 .5"></path><path d="M10 18v3"></path><path d="M14 17.75V21"></path><path d="M7 18a6 6 0 0 0 3.84-10.61"></path></svg>
          <h2>No Data Found</h2></div>}
        </SlDrawer>
        <SlDrawer
          label="Notifications"
          open={showWebpushNotifications}
          className="notification-board"
          onSlRequestClose={handlWebNotificationRequestClose}
          onSlAfterHide={() => {
            setpushload(false);
            setHasMore(true);
            setwebPage(1)
            setwebNotifications([]);
            setShowWebpushNotifications(false);
          }}
          style={{ "--size": "640px" }}        >
        <div style={{ maxHeight: '80vh', overflowY: 'auto' }} onScroll={handleScroll}>
        {webnotifications.map((notification) => (
            <div
              key={notification?.noti_id}
              className={`notification-item px-2 mb-1 rounded-lg border transition-colors duration-300 ${
                notification?.read === 1 ? 'bg-gray-200' : 'bg-white'
              } hover:bg-gray-100 cursor-pointer`} 
              onClick={() => handleNotificationClick(notification?.noti_id,notification?.read)}
            >
                <div className="flex justify-between items-center">
                  <h6 className="text-lg text-gray-800 font-semibold">{notification?.title}</h6>
                  <p className="text-sm text-gray-500">{formatDateWithTime(notification?.date)}</p>
                </div>
                <div className="flex justify-between items-center">
                  <p className="italic text-gray-600">{notification?.creative_name}</p>
                  <p className="font-semibold text-gray-600">Done by: {notification?.name}</p>
                </div>
                <p className="text-gray-700">{notification?.message}</p>
            </div>
          ))}
        {!pushload && hasMore && <div>Loading...</div>}
        {!hasMore && <div>No more notifications</div>}
      </div>
     
    </SlDrawer>
        <aside className="flex items-center gap-2 ml-1 mobLogMenu">
          {/* {<div className='flex flex-col'>
                    <span className="text-black-600 whitespace-nowrap">Session expires in: </span>
                    <span className="text-red-400">{hours}h {minutes}m {seconds}s</span>
                  </div>}                 */}
          {/* <img src="../images/ic-profile.png" alt="" className="w-8 h-8" /> */}
          {localStorage.getItem("role") === roles.salesperson && (
            <div className="text-2xl notification">
              <sl-tooltip content="Notifications">
                <sl-icon-button
                  library="lucide"
                  onClick={() => {fetchSalesNotifications(); setShowSalesNotifications(true);}}
                  name="bell"
                ></sl-icon-button>
              </sl-tooltip>
              {(salesNotifications.events?.length > 0 || salesNotifications.remainders?.length > 0) && (
                <span className="pill"></span>
              )}
            </div>
          )}
          {(localStorage.getItem("role") === roles.ops || localStorage.getItem("role") === roles.designer) && (
            <div className="text-2xl notification">
              <sl-tooltip content="Notifications">
                <sl-icon-button
                  library="lucide"
                  onClick={()=>{setwebNotifications([]);fetchwebpushNotifications();setShowWebpushNotifications(true)}}
                  name="bell"
                ></sl-icon-button>
              </sl-tooltip>
              {(salesNotifications.events?.length > 0 || salesNotifications.remainders?.length > 0) && (
                <span className="pill"></span>
              )}
            </div>
          )}
          {localStorage.getItem("role") === roles.financer && (
            <>
              {" "}
              <audio
                style={{ display: "none" }}
                src={NotificatinAudio}
                ref={audioRef}
                typeof="audio/wav"
              ></audio>
              <div className="text-2xl notification">
                <sl-tooltip content="Notifications">
                  <sl-icon-button
                    library="lucide"
                    onClick={() => {
                      setShowNotifications(true);
                    }}
                    name="bell"
                  ></sl-icon-button>
                </sl-tooltip>
                {(notify || notifications.length > 0) && (
                  <span className="pill"></span>
                )}
              </div>
            </>
          )}
          <img
            src={filterSvg}
            onClick={() => setShowFilter(true)}
            alt="filter"
            className="mobileOnly"
          ></img>
          <div
            className="flex pl-5 pr-5 align-items-center header-item bg-soft-light border-start border-end show"
            id="page-header-user-dropdown"
            data-bs-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="true"
          >
            <img
              className="rounded-circle header-profile-user mr-4"
              title={localStorage.getItem("name")}
              src={profileAvatar}
              alt="Header Avatar"
              onClick={() => {
                setProfile(true);
              }}
            />
          </div>
          {/* <SlButton size="medium" variant="primary" onClick={logout}>
                    Logout
                  </SlButton> */}
        </aside>
      </header>
      <SlDrawer
        open={showFilter}
        onSlRequestClose={handleRequestClose}
        placement="bottom"
        noHeader
        onSlAfterHide={()=>{}}
        style={{ "--size": "fit-content" }}
      >
        <div className="relative">
        <h3 className="mb-3">Apply Filters</h3>
        <hr></hr>
        <div className="flex items-center gap-8 justify-center w-full flex-wrap">
          {(component === 15 &&
            roles.salesperson === localStorage.getItem("role") &&
            salesRegionExists === 0) ||
          component === 10 ||
          component === 26 ||
          component === 33 ||
          component === 35 ||
          component === 36 ||
          component === 34 ||
          component === 38 ||
          component === 42 ||
          component === 43 ||
          component === 45 ||
          component === 48 ||
          component === 52 ||
          component === 65 ||
          component === 67 ||
          component === 80 ||
          component === 85 ||
          component === 86 ||
          component === 39 ? null : (
            <>
              {(localStorage.getItem("role") === roles.ops ||
                localStorage.getItem("role") === roles.financer ||
                mainSalesUser === 1) &&
              localStorage.getItem("role") !== roles.network_ad_manager &&
              localStorage.getItem("role") !== roles.b2b ? (
                <SlSelect
                  placeholder="Select Type"
                  defaultValue={"all"}
                  size="large"
                  label="User Type"
                  className="w-full"
                  onSlChange={onTypeChange}
                  value={user_type}
                >
                  {/* <sl-icon name="globe-central-south-asia" slot="prefix"></sl-icon> */}
                  <SlOption value="0">All</SlOption>
                  <SlOption value="1">National</SlOption>
                  <SlOption value="2">Local</SlOption>
                  {mainSalesUser === 1 && component === 1 && (
                    <SlOption value="3">Heads</SlOption>
                  )}
                </SlSelect>
              ) : null}
              {localStorage.getItem("role") !== roles.advertiser &&
              localStorage.getItem("role") !== roles.network_ad_manager &&
              localStorage.getItem("role") !== roles.b2b ? (
                <SlSelect
                  label="Region"
                  placeholder="Select Region"
                  defaultValue={"all"}
                  size="large"
                  className="w-full"
                  disabled={
                    localStorage.getItem("role") === roles.salesperson &&
                    regionexists
                  }
                  onSlChange={onregionchange}
                  value={region}
                >
                  {/* <SlIcon library="lucide" name="map-pin" slot="prefix"></SlIcon> */}
                  <SlOption key={0} value={"region-0"}>
                    All Regions
                  </SlOption>
                  {regionsdata?.map((option) => (
                    <SlOption
                      key={option.index + 1}
                      value={option.type + "-" + option.value}
                    >
                      {option.label}
                    </SlOption>
                  ))}
                </SlSelect>
              ) : null}
              {localStorage.getItem("role") !== roles.advertiser &&
              localStorage.getItem("role") !== roles.network_ad_manager &&
              localStorage.getItem("role") !== roles.b2b &&
              region ? (
                <SlSelect
                  label="Location"
                  placeholder="Select Location"
                  defaultValue={"all"}
                  size="large"
                  disabled={
                    localStorage.getItem("role") === roles.salesperson &&
                    regionexists &&
                    locationexists !== 0
                      ? true
                      : false
                  }
                  onSlChange={onlocationchange}
                  className="w-full"
                  value={location}
                >
                  {/* <SlIcon library="lucide" name="locate-fixed" slot="prefix"></SlIcon> */}
                  <SlOption key={0} value={"location-0"}>
                    All Locations
                  </SlOption>
                  {locationsdata?.map((option) => (
                    <SlOption
                      key={option.index + 1}
                      value={option.type + "-" + option.value}
                    >
                      {option.label}
                    </SlOption>
                  ))}
                </SlSelect>
              ) : null}
              {component !== 1 && (
                <>
                  {(localStorage.getItem("role") === roles.ops ||
                      localStorage.getItem("role") === roles.financer || (localStorage.getItem('role') === roles.salesperson ? salesUsersList?.length > 1 : true)) ? (
                        <div>
                        <Select
                            className="w-full"
                            placeholder="Select User"
                            size="medium"
                            value={defaultValue(data, saleop)}
                            onChange={(selected) => changeNameHandler({target: {value: selected.value}})}
                            options={data?.map((option) => {
                                if (option.label.includes("Sales")) {
                                  return ({label : option.label, value: option.index});
                                }
                                return {label: option.label, value: option.index};
                              })}
                        />
                        </div>
                  ) : null}
                </>
              )}
            </>
          )}
          {component !== 7 &&
          component !== 33 &&
          component !== 35 &&
          component !== 38 &&
          component !== 34 &&
          component !== 42 &&
          component !== 43 &&
          component !== 45 &&
          component !== 48 &&
          component !== 52 &&
          component !== 36 &&
          component !== 26 &&
          component !== 65 &&
          component !== 80 &&
          component !== 67 &&
          component !== 85 &&
          component !== 86 &&
          localStorage.getItem("role") !== roles.network_ad_manager &&
          localStorage.getItem("role") !== roles.b2b ? (
            <>
            <div className="border rounded-lg  border-gray-300 hover:cursor-pointer hover:border-2 hover:border-sky-500 w-full">
              <Datepicker
                classNames="form-input w-full"
                value={value}
                primaryColor={"cyan"}
                showShortcuts={true}
                // useRange={false}
                configs={{
                  shortcuts: {
                    today: "today",
                    yesterday: "yesterday",
                    currentMonth: "currentMonth",
                    pastMonth: "lastMonth",
                  },
                }}
                onChange={handleValueChange}
              />
            </div>
            </>
          ) : null}

          {localStorage.getItem("main_user") && (
            <div className="ml-auto">
              <SlSelect
                placeholder="Select User Type"
                size="large"
                className="w-full"
                label="Switch User"
                onSlChange={onMainUserOptionChange}
                value={selectedUserOfMain}
              >
                {/* <SlIcon library="lucide" name="locate-fixed" slot="prefix"></SlIcon> */}
                {mainUsersArray?.map((option) => (
                  <SlOption key={option.index} value={option.value}>
                    {option.label}
                  </SlOption>
                ))}
              </SlSelect>
            </div>
          )}
          <SlButton variant="primary" className="w-full" size="large" onClick={()=>setShowFilter(false)}>APPLY</SlButton>
                    
        </div>
        <SlIcon
            className="absolute top-1 right-1 text-2xl hover:text-red-600 cursor-pointer"
            name="x-circle"
            onClick={() => setShowFilter(false)}
          ></SlIcon>
        </div>
      </SlDrawer>
    </>
  );
}

export default Header;
